import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { FiGithub } from "react-icons/fi";
import { BsInstagram, BsWhatsapp } from "react-icons/bs";

const skills = [
  "HTML5", "CSS3", "JavaScript", "React",
  "Bootstrap", "Tailwind CSS", "Sass",
  "C", "C++", "DSA", "Algorithms",
  "WordPress", "Figma", "Git", "GitHub",
];

const AboutUs = () => {
  return (
    <section className="about-us section-padding" id="about-us">
      <div className="container">
        {/* Section header */}
        <div
          className="text-center section-header"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <span className="sec-label">About Me</span>
          <h2 className="sec-title">Who I Am</h2>
          <div className="sec-line" />
        </div>

        <div className="row gx-5 align-items-center">
          {/* Image */}
          <div
            className="col-lg-5 mb-5 mb-lg-0"
            data-aos="fade-right"
            data-aos-duration="900"
            data-aos-delay="100"
          >
            <div className="about-us__image-wrapper">
              <img
                className="img-fluid"
                src="assets/images/tamim-hero-image.jpg"
                alt="Abdul Aziz"
              />
            </div>
          </div>

          {/* Content */}
          <div
            className="col-lg-7"
            data-aos="fade-left"
            data-aos-duration="900"
            data-aos-delay="200"
          >
            <div className="about-us__content">
              <h3 className="about-us__title">
                Hello, I&rsquo;m <span>Abdul Aziz</span>
              </h3>

              <p className="about-us__bio">
                I&rsquo;m a passionate Frontend Developer and Diploma Engineering student in Computer
                Science &amp; Engineering, with a strong focus on modern web technologies and algorithmic
                problem solving. I aim to build a career as a Professional Software Engineer in Bangladesh&rsquo;s
                growing software industry.
              </p>
              <p className="about-us__bio">
                I actively practice competitive programming and have solved 500+ problems across Codeforces
                and CodeChef, achieving a 3★ rating. I love learning new technologies and turning ideas into
                polished, production-ready experiences.
              </p>

              {/* Stats */}
              <div className="about-us__stats">
                <div className="about-us__stat">
                  <span className="about-us__stat-number">500+</span>
                  <span className="about-us__stat-label">Problems Solved</span>
                </div>
                <div className="about-us__stat">
                  <span className="about-us__stat-number">1637</span>
                  <span className="about-us__stat-label">Peak CodeChef Rating</span>
                </div>
                <div className="about-us__stat">
                  <span className="about-us__stat-number">6+</span>
                  <span className="about-us__stat-label">Projects Built</span>
                </div>
              </div>

              {/* Skills */}
              <p className="about-us__skills-title">Technologies &amp; Tools</p>
              <div className="about-us__skills">
                {skills.map((skill) => (
                  <span key={skill} className="about-us__skill-chip">
                    {skill}
                  </span>
                ))}
              </div>

              {/* Social */}
              <ul className="social-icon">
                <li>
                  <a
                    href="https://www.facebook.com/imtamimaziz"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Facebook"
                  >
                    <FaFacebookF />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/imtamimaziz/"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Instagram"
                  >
                    <BsInstagram />
                  </a>
                </li>
                <li>
                  <a href="https://wa.me/8801887538750" aria-label="WhatsApp">
                    <BsWhatsapp />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/abdul-aziz-tamim-611b2b306/"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="LinkedIn"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/aziz-tamim"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="GitHub"
                  >
                    <FiGithub />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
